module.exports = __webpack_public_path__ + "images/5c16f5c4543e5447ab889a26fa8e60ad-MSW_LineArt_Numbers(3)_slide19.png";